"use strict";

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const HEADER = document.getElementById("header");
const headerRects = HEADER.getBoundingClientRect();
const headerHeight = headerRects.height + headerRects.top;

let lastScrollTop = 0;

document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);

setTimeout(() => {
	const numberLocations = document.querySelectorAll(".attraction__info p a[href^='tel']");
	if (numberLocations.length > 0) {
		numberLocations.forEach(link => {
			link.classList.add('track-phone');
		});
	}
}, 5000)

const animateTo = (target) => {
	const toTarget = document.getElementById(target);

	if (!toTarget)
		return;

	const from = window.scrollY;
	const to = toTarget.getBoundingClientRect().top + from - headerHeight;
	const duration = 1400;
	const start = performance.now();

	const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

	function step(timestamp) {
		const time = timestamp - start;
		const progress = Math.min(time / duration, 1);
		const yH = easeInOutQuart(progress) * (to - from) + from;

		window.scrollTo(0, yH);

		time < duration && requestAnimationFrame(step);
	}

	requestAnimationFrame(step);
};

const scrollW = () => {
	const scrollTop = document.documentElement.scrollTop;

	if (scrollTop < 80) {
		HEADER.classList.remove('up', 'down');
	} else {
		HEADER.classList.toggle('down', scrollTop > lastScrollTop);
		HEADER.classList.toggle('up', scrollTop <= lastScrollTop);
	}
	lastScrollTop = Math.max(scrollTop, 0);
};

(() => {
	window.addEventListener('scroll', scrollW);

	// DOM CLEANUP (TinyMCE)
	for (const p of document.getElementsByTagName("p"))
		p.children.length === 0 && p.textContent.trim() === '' && p.remove();

	// WEATHER
	const weatherEls = document.getElementsByClassName("js-weather");

	if (weatherEls.length) {
		fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=0ddd1af8b5b1833cedd6da7a90934cce&units=imperial&exclude=current,minutely,daily,alerts&units=metric`)
			.then(res => res.json())
			.then(data => {
				const icon = data.weather[0].icon,
					temp = Math.trunc(data.main.temp),
					description = Math.trunc(data.main.description);

				for (const el of weatherEls) {
					el.style.setProperty("--icon", `url(${SITE_FILES}svg/weather/${icon}.svg)`);
					el.textContent = `${temp} \u00B0F`;
				}
			});
	}

	// TITLE ANIMATION
	const escMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
	const esc = s => s.replace(/[&<>"']/g, match => escMap[match]);

	document.querySelectorAll("[class*=sym-h] em, [class*=sym-uvp] em, .title em, .form-module h2 em").forEach(el => {
		let globalIdx = 0;
		let newHtml = '';

		el.childNodes.forEach(node => {
			if (node.nodeType === Node.TEXT_NODE) {
				const parts = node.textContent.match(/\S+|\s+/g) || [];

				newHtml += parts.map(part => {
					if (/\s+/.test(part)) {
						return part;
					} else {
						const letters = Array.from(part).map(ch =>
							`<i style="--idx: ${globalIdx++};">${esc(ch)}</i>`
						).join('');

						return letters;
					}
				}).join('');
			} else {
				newHtml += node.outerHTML || node.textContent;
			}
		});

		el.innerHTML = newHtml;
	});

	// SCROLL ANIMATIONS (Hash Links)
	window.location.hash && animateTo(window.location.hash.substring(1));

	document.querySelectorAll('[href*="#"]:not([data-lbx])').forEach(cta => {
		const target = cta.hash.substring(1);

		if (!document.getElementById(target)) return;

		cta.addEventListener("click", (e) => {
			e.preventDefault();
			animateTo(target);
		});
	});

	// TOGGLE BUTTONS
	const toggleGroups = new Map();

	const getPanel = (el) => {
		const target = el.dataset.target;
		if (target)
			return document.getElementById(target);

		const next = el.nextElementSibling;
		return (next && next.hasAttribute('aria-expanded')) ? next : null;
	};

	const deactivate = (currentlyActive) => {
		currentlyActive.summary.classList.remove("active");
		currentlyActive.content && currentlyActive.content.setAttribute("aria-expanded", false);
	};

	document.addEventListener("click", (e) => {
		const el = e.target.closest(".js-toggle-active");
		if (!el) return;

		const groupKey = el.dataset.group || el,
			action = el.dataset.action || "toggle",
			currentlyActive = toggleGroups.get(groupKey);

		if (action === "close") {
			if (currentlyActive) {
				deactivate(currentlyActive);
				toggleGroups.delete(groupKey);
			}
			return;
		}

		currentlyActive && currentlyActive.summary !== el && deactivate(currentlyActive);

		const panel = getPanel(el);

		if (action === "open") {
			el.classList.add("active");
			panel && panel.setAttribute("aria-expanded", "true");
			toggleGroups.set(groupKey, { summary: el, content: panel });
			return;
		}

		const nowActive = el.classList.toggle("active");
		panel && panel.setAttribute("aria-expanded", nowActive);

		if (nowActive)
			toggleGroups.set(groupKey, { summary: el, content: panel });
		else
			toggleGroups.delete(groupKey);
	});

	// OBSERVERS
	const animationObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add("fade-in");
				animationObserver.unobserve(entry.target);
			}
		});
	});

	const resizeObserver = new ResizeObserver(entries => {
		entries.forEach(entry => {
			const el = entry.target;
			const targetEl = el.dataset.target ? document.getElementById(el.dataset.target) : el;
			targetEl && targetEl.style.setProperty("--offset", `${el.scrollHeight}px`);
		});
	});

	// TRACKERS
	const initializedTrackers = new WeakSet();

	const updateTrackerPosition = (element, target) => {
		element.style.cssText = `left: ${target.offsetLeft}px; width: ${target.offsetWidth}px;`;
	};

	const initTracker = (tracker) => {
		if (initializedTrackers.has(tracker)) return;
		initializedTrackers.add(tracker);

		const parent = tracker.parentElement;
		let activeTab = parent.querySelector(".active") || parent.firstElementChild;

		new ResizeObserver(() => {
			updateTrackerPosition(tracker, activeTab);
		}).observe(parent);

		parent.addEventListener("click", (e) => {
			const target = e.target.closest("button");

			if (!target)
				return;

			activeTab.classList.remove("active");
			target.classList.add("active");
			activeTab = target;

			updateTrackerPosition(tracker, activeTab);

			activeTab.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'center'
			});
		});
	};

	// DYNAMIC ELEMENT INITIALIZER
	const addAnimations = (selector, behavior = null) => {
		document.querySelectorAll(selector).forEach(item => item.classList.add("animate-fade", behavior));
	};

	const initDynamicElements = (container = document) => {
		addAnimations(".global-sitemap", "top");
		addAnimations(".form-module-wrapper");
		addAnimations(".form-module h2");
		addAnimations(".sitemap .sym-h1", "bottom");

		container.querySelectorAll(".animate-fade").forEach(el => animationObserver.observe(el));
		container.querySelectorAll(".js-offset").forEach(el => resizeObserver.observe(el));

		container.querySelectorAll(".js-tab-tracker").forEach(tracker => initTracker(tracker));

		container.querySelectorAll(".js-toggle-active.active").forEach(el => {
			const key = el.dataset.group || el;
			toggleGroups.set(key, { summary: el, content: getPanel(el) });
		});
	};

	initDynamicElements();

	let observerTimeout;

	const domObserver = new MutationObserver(mutations => {
		let shouldUpdate = false;

		for (const mutation of mutations) {
			if (mutation.addedNodes.length > 0) {
				for (const node of mutation.addedNodes) {
					if (node.nodeType === 1) {
						shouldUpdate = true;
						break;
					}
				}
			}
			if (shouldUpdate) break;
		}

		if (shouldUpdate) {
			clearTimeout(observerTimeout);
			observerTimeout = setTimeout(() => {
				initDynamicElements();
			}, 50);
		}

		for (const [key, val] of toggleGroups.entries()) {
			if (!document.contains(val.summary)) {
				toggleGroups.delete(key);
			}
		}
	});


	domObserver.observe(document.body, { childList: true, subtree: true });
})();